import React, { PureComponent } from "react";

import { Error, Metric } from "components/Utils/Utils.js";

import Heading from "components/Elements/Heading";

class MarqueeFreeTrialStarts extends PureComponent {
  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={480} />;
    }

    return (
      <div className="row mt-2 mb-2">
        <div className="col mb-3 mb-sm-0">
          <Heading size={6} className={"mb-1"}>
            Free Trial Conversion
          </Heading>

          <div className="d-flex">
            <Metric
              {...data.metrics.free_trial_conversion}
              size={"lg"}
              format={"%"}
              type={"percentage"}
            />
          </div>
        </div>

        <div className="col mb-3 mb-sm-0">
          <Heading size={6} className={"mb-1"}>
            Monthly Trials
          </Heading>

          <div className="d-flex">
            <Metric
              {...data.metrics.monthly_trials}
              size={"lg"}
              format={"%"}
              type={"percentage"}
            />
          </div>
        </div>

        <div className="col mb-3 mb-sm-0">
          <Heading size={6} className={"mb-1"}>
            Annual Trials
          </Heading>

          <div className="d-flex">
            <Metric
              {...data.metrics.annual_trials}
              size={"lg"}
              format={"%"}
              type={"percentage"}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MarqueeFreeTrialStarts;
